<template>
  <div class="star-wrap">
        <div class="star-title">酒店简介</div>
        <div class="star-content">
            <div>酒店名称：{{ info.title }}</div>
        </div>
        <div class="star-content">
            <div>酒店星级：{{info.star | formatVar('HotelStar')}}</div>
        </div>
        <div class="star-content">
            <div>开业时间：{{ info.startdate| formatTimestamp(6) }}年</div>
            <div>最近装修：{{ info.fitmentdate| formatTimestamp(6) }}年</div>
        </div>
        <div class="star-content">
            <div >早餐提供：<span v-for="item in info.breakfast_type" class="mr-1" :key="item">{{item| formatVar('breakfastHotel')}}</span></div>
        </div>
        <div class="star-content">
            <div >早餐时间：{{info.breakfast_time.replace(',','-')}}</div>
        </div>
        <div class="star-content">
            <div>联系电话：
                <p class="tel">
                    <span v-for="item in info.hotel_tel.split(',')" :key="item">{{ item }}</span>
                </p>
            </div>
        </div>
        <div>
        <p class="h7 mt-2 format-text" v-if="info.intro"
            v-html="introText"></p>
          <p class="h7 mt-2 format-text" v-else>欢迎通过订单雨预订本酒店，享受团队最优价，期待您的光临</p>
        </div>
  </div>
</template>

<script>
export default {
  name: 'Star',
  components: {},
  props: {
    info: {
        type: Object,
        default: () => ({})
    },
  },
  data() {
    return {
    };
  },
  computed: {
    //富文本信息
    introText(){
        let str=this.info.intro
        str = str.replace(/&nbsp;/g, '');
        return str
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
    .format-text{
        text-indent: 2em;
        font-size: 14px !important;
        text-align: justify;
        background-color: #f5f7fa;
        padding: 12px;
        border-radius: 6px;
    }
    .star-wrap{
        width: 94%;
        margin: 18px auto;
    }
    .star-title{
        width: 100%;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        margin: 10px 0;
    }
    .star-content{
        text-align: left;
        display: flex;
        color: #333;
        margin-bottom: 12px;
        div{
            margin-right: 20px;
            min-width: 60px;
            line-height: 24px;
            display: flex;
        }
        .tel{
            span{
                display: block;
            }
        }
    }
</style>
